import { request } from './request'

export const listSupplierBillBySupplierNamePopUp = (params) =>
  request({
    url: `/api/stock/supplier_bill/supplier_name/list`,
    method: 'get',
    params: params ?? null,
  })